import { Stack, Text, Image, Link, HStack, Box, Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";
import black from "../assets/badge-black.svg";
import white from "../assets/badge-white.svg";
import phone from "../assets/phone.png";

export default function Home() {
	return (
		<Flex
			flex={1}
			overflow="hidden"
			direction={{ base: "column", md: "row" }}
			align="center"
			justify="center"
			gap={{ base: 8, md: 0 }}
		>
			<Stack
				flex={1}
				gap={6}
				justify="center"
				align={{ base: "center", md: "flex-start" }}
				textAlign={{ base: "center", md: "left" }}
				px={{ base: 6, md: 16 }}
				py={{ base: 10, md: 0 }}
				maxW={{ md: "540px" }}
				ml={{ md: "auto" }}
			>
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6 }}
				>
					<Text fontSize="6xl" fontWeight="bold" lineHeight="1.1">
						Every day
						<br />
						matters
					</Text>
				</motion.div>

				<motion.div
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6, delay: 0.15 }}
				>
					<Text color="fg.muted" maxW="420px">
						Pondero widgets help you visualize time, create urgency, and make sure every day matters.
					</Text>
				</motion.div>

				<motion.div
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6, delay: 0.3 }}
				>
					<Link href="https://apps.apple.com/app/id6758339557">
						<Image className="asset-black" src={black} alt="Download on the App Store" width="160px" />
						<Image className="asset-white" src={white} alt="Download on the App Store" width="160px" />
					</Link>
				</motion.div>

				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 0.6, delay: 0.45 }}
				>
					<HStack gap={4}>
						<Link href="/terms" fontSize="xs" color="fg.subtle">
							Terms
						</Link>
						<Link href="/privacy" fontSize="xs" color="fg.subtle">
							Privacy
						</Link>
						<Link href="mailto:hello@pondero.app" fontSize="xs" color="fg.subtle">
							Contact
						</Link>
					</HStack>
				</motion.div>
			</Stack>

			<Flex
				flex={1}
				align="center"
				justify="center"
				position="relative"
				alignSelf="stretch"
				maxW={{ md: "540px" }}
				mr={{ md: "auto" }}
			>
				<motion.div
					initial={{ opacity: 0, y: 60 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.7, delay: 0.3 }}
					style={{ position: "relative", display: "flex", alignItems: "center" }}
				>
					<Box className="phone-glow" />
					<Image src={phone} alt="Pondero app preview" className="phone" position="relative" zIndex={1} />
				</motion.div>
			</Flex>
		</Flex>
	);
}
